import axios from "axios";
import { ArrowUpDown } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { DataTable } from "src/components/DataTable";
import { Button } from "src/components/ui/button";
import LoaderPage from "../../../../../components/LoaderPage";
import { useAuth } from "../../../../../context/AuthContext";
import { useLanguage } from "../../../../../context/LanguageContext";
import { BaseUrlApi, ErrorMessage } from "../../../../../lib/api";
import { LessonTeacherData, SubLessonData } from "../../../../../lib/languages";
import DrawerQuizShowAnswer from "./DrawerQuizShowAnswer.jsx";

export default function ShowQuizAnswer() {
  const { language } = useLanguage();
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const t = SubLessonData[language] || SubLessonData["en"];

  // Attempt Quiz
  const [loadingAttemptQuiz, setLoadingAttemptQuiz] = useState(false);
  const [attemptQuiz, setAttemptQuiz] = useState([]);

  const getAllAttemptQuiz = async () => {
    try {
      const { data } = await axios.get(
        `${BaseUrlApi}/quizzes/attemptQuiz/${id}`
      );
      setAttemptQuiz(data.data);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingAttemptQuiz(false);
    }
  };

  useEffect(() => {
    setLoadingAttemptQuiz(true);
    getAllAttemptQuiz();
  }, [id]);

  if (loadingAttemptQuiz) {
    return <LoaderPage title={t.loadingAttemptQuiz} />;
  }

  const columns = [
    {
      accessorKey: `user.name`,
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.name}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
    },
    {
      accessorKey: "user.email",
      header: t.email,
    },
    {
      accessorKey: "user.phone",
      header: t.phone,
    },
    {
      accessorKey: "score",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.score}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
    },
    {
      id: "actions",
      header: t.showAnswers,
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="flex items-center gap-2">
            <DrawerQuizShowAnswer
              quizData={item}
              getAllAttemptQuiz={getAllAttemptQuiz}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="space-y-10" dir={language === "ar" ? "rtl" : "ltr"}>
      <div>
        <div className="text-2xl font-bold">{t.quizAnswersTitle}</div>
        <DataTable
          columns={columns}
          data={attemptQuiz}
          title={t.usersByName}
          filterNames={["user_name", "user_email", "score"]}
        />
      </div>
    </div>
  );
}
